
import '../App.css';
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { ref, query, limitToLast, onValue, off, orderByChild, get, limitToFirst } from "firebase/database";
import { useNavigate } from 'react-router-dom';
import { db } from '../config';
import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style
import "@fontsource/poppins"; // Defaults to weight 400
import "@fontsource/poppins/400.css"; // Specify weight
import "@fontsource/poppins/400-italic.css"; // Specify weight and style
import { FaArrowRightLong } from "react-icons/fa6";
import { LuPhoneCall } from "react-icons/lu";
import { RiNurseFill } from "react-icons/ri";
import { toast } from 'wc-toast'
import { IoHeadsetOutline } from "react-icons/io5";
import { LuHeartPulse } from "react-icons/lu";
import { FaSpotify } from "react-icons/fa";
import { GrApple } from "react-icons/gr";
import BG from "../bg1.jpg";

import LOGO from "../logo2.png";


import host1 from "../host2.jpg";

import host2 from "../host1.png";


import acast from "../acast.png";


import acast1 from "../acast1.png";


import clinic from "../clinic1.jpg";



function Home() {

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);
    const navigate = useNavigate();


    useEffect(() => {
        const onResize = () => {
            setScreenWidth(window.innerWidth);
            setScreenHeight(window.innerHeight);
        };
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    ////////////////////////////////////////////////////////////////////////////////////////////


    const [episodes, setAll_episods] = useState([]);


    useEffect(() => {
        let alive = true;

        (async () => {
            try {
                const qRef = query(
                    ref(db, "rss_feed_fake_items/items"),
                    orderByChild("episodeNumber"),
                    limitToFirst(10)
                );

                const snap = await get(qRef);
                if (!alive) return;

                if (!snap.exists()) {
                    setAll_episods([]);
                    return;
                }

                const episodes = Object.entries(snap.val()).map(([id, item]) => ({
                    item_id: id,
                    ...item,
                }));

                // keep them ordered 1..10 (sometimes object order can differ)
                episodes.sort((a, b) => (a.publishedAtMs || 0) - (b.publishedAtMs || 0));

                setAll_episods(episodes);
            } catch (e) {
                console.log("fetch first 10 episodes error:", e);
                if (alive) setAll_episods([]);
            }
        })();

        return () => {
            alive = false;
        };
    }, []);


    console.log("vvvvvvvvvvvvvvvvv", episodes)


    ////////////////////////////////////////////////////////////////////////////////////////////
    const isMobile = screenWidth <= 924;

    // ✅ scale based on the actual HERO width (no hard caps)
    const scale = (n) => {
        const heroPx = isMobile ? screenWidth : screenWidth * 0.97; // hero is 95% on desktop
        const DESIGN_W = 1832; // only used as a ratio reference (not a cap)

        const raw = heroPx / DESIGN_W;

        // keep it premium (avoid too small / too huge)
        const s = Math.max(0.85, Math.min(1.15, raw));

        return Math.round(n * s);
    };

    // ✅ white spacing around hero (top = sides)
    const pagePad = isMobile ? 14 : Math.max(18, Math.min(44, screenWidth * 0.022));

    // ✅ figma ratio (only ratio, not fixed px)
    const FIGMA_W = 1832;
    const FIGMA_H = 1004;
    const FIGMA_RATIO = FIGMA_H / FIGMA_W; // ≈ 0.548


    // ✅ Hero pixel width (needed for height calc + scaling)
    const heroWpx = isMobile
        ? Math.round(screenWidth * 0.97)
        : Math.round(screenWidth * 0.97);

    // ✅ keep same ratio for height on desktop, safe min-height on mobile
    const heroMinH = isMobile
        ? Math.max(640, Math.round(screenHeight * 0.82))
        : Math.round(heroWpx * FIGMA_RATIO);

    // ✅ inner padding inside hero (also controls bottom-right spacing of cards)
    const heroInset = isMobile ? 12 : 22;

    const headerRowH = isMobile ? 56 : 70;

    ///////////////////////////////////////////////////////////////////////////////

    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [activeNav, setActiveNav] = useState(null);

    const navItems = useMemo(
        () => ["Home", "Episodes", "About Hosts", "Mission"],
        []
    );

    ////////////////////////////////////////////////////////////////////////////////
    // ✅ state (top of component)
    const [showAllEpisodes, setShowAllEpisodes] = useState(false);


    // ✅ visible list


    // demo states (place near top of component)
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [comment, setComment] = useState("");

    const onSubmitGetInvolved = async () => {

        if (firstName != '' && lastName != '' && comment != '' && email != '') {

            const room = db.ref('Get_involved')

            const ID = new Date().getTime()


            const obj = { Email: email, Name: firstName, Surname: lastName, Comment: comment, id: ID }
            await room.child(String(ID)).set(obj)
            toast.success('Your message has been sent')
            setFirstName('')
            setEmail('')
            setLastName("")
            setComment("")
            //  scrollTohome()

        }


        else {

            toast.error('Please fill up all required info')
        }



    };



    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////


    function smoothScrollTo(container, targetY, duration = 1200) {
        const startY = container === window ? window.scrollY : container.scrollTop;
        const startTime = performance.now();

        function easeInOutCubic(t) {
            return t < 0.5
                ? 4 * t * t * t
                : 1 - Math.pow(-2 * t + 2, 3) / 2;
        }

        function animate(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = easeInOutCubic(progress);

            const currentY = startY + (targetY - startY) * eased;

            if (container === window) {
                window.scrollTo(0, currentY);
            } else {
                container.scrollTop = currentY;
            }

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        }

        requestAnimationFrame(animate);
    }


    const homeRef = useRef(null);


    const scrollTohome = () => {
        const y =
            homeRef.current.getBoundingClientRect().top +
            window.scrollY -
            50; // header offset

        smoothScrollTo(window, y, 1200);
    };

    const episodsRef = useRef(null);


    const scrollToEpi = () => {
        const y =
            episodsRef.current.getBoundingClientRect().top +
            window.scrollY -
            50; // header offset

        smoothScrollTo(window, y, 1200);
    };


    const hostRef = useRef(null);


    const scrollTohost = () => {
        const y =
            hostRef.current.getBoundingClientRect().top +
            window.scrollY -
            50; // header offset

        smoothScrollTo(window, y, 1200);
    };


    const missiontRef = useRef(null);


    const scrollTomission = () => {
        const y =
            missiontRef.current.getBoundingClientRect().top +
            window.scrollY -
            50; // header offset

        smoothScrollTo(window, y, 1200);
    };

    const ConcactRef = useRef(null);


    const scrollToconcact = () => {
        const y =
            ConcactRef.current.getBoundingClientRect().top +
            window.scrollY -
            50; // header offset

        smoothScrollTo(window, y, 1200);
    };



    useEffect(() => {
        if (activeNav === "Episodes") {
            scrollToEpi(); // your slow smooth scroll
        }

        if (activeNav === "About Hosts") {
            scrollTohost();
        }

        if (activeNav === "Home") {
            scrollTohome();
        }

        if (activeNav === "Mission") {
            scrollTomission();
        }
        if (activeNav === "Contact") {
            scrollToconcact();
        }

    }, [activeNav]);

    //////////////////////////////////////////////////////////////////////////////////////////////

    // ✅ Put these helpers ABOVE return()

    // (optional) keep your links in one place
    const SUBSCRIBE_LINKS = {
        spotify: "https://open.spotify.com/",       // <-- put your real link
        apple: "https://podcasts.apple.com/",  // <-- put your real link
        acast: "https://shows.acast.com/thenurseandthemidwife", // <-- put your real link
    };

    // ✅ per-platform logic (you can change each one differently)
    const onSubscribeClick = (platform) => {
        // Example: different logic per button
        if (platform === "spotify") {
            // 1) open spotify page
            window.open(SUBSCRIBE_LINKS.spotify, "_blank", "noopener,noreferrer");
            return;
        }

        if (platform === "apple") {
            // 2) apple podcasts (different link or tracking)
            // You can do analytics here
            // track("subscribe_click", { platform: "apple" });
            window.open(SUBSCRIBE_LINKS.apple, "_blank", "noopener,noreferrer");
            return;
        }

        if (platform === "acast") {
            // 3) Acast (maybe same tab, or navigate internal, or open)
            window.open(SUBSCRIBE_LINKS.acast, "_blank", "noopener,noreferrer");
            return;
        }
    };

    // ✅ small helper to keep your "press" effect clean (works on mouse + touch)


    const pressDown = (e) => {
        e.currentTarget.style.transform = "scale(0.98)";
    };

    const pressUp = (e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.background = "rgba(255,255,255,0.12)";
    };

    const hoverIn = (e) => {
        e.currentTarget.style.background = "rgba(255,255,255,0.16)";
    };
    const hoverIn1 = (e) => {
        e.currentTarget.style.background = "#1F6F7840";
    };
    const hoverIn2 = (e) => {
        e.currentTarget.style.background = "#00C9C4";
    };

    const hoverOut = (e) => {
        e.currentTarget.style.background = "transparent";
    };


    const hoverOut2 = (e) => {
        e.currentTarget.style.background = "rgba(255,255,255,0.16)";
    };

    const hoverOut1 = (e) => {
        e.currentTarget.style.background = "#0F6E73";
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////////


    // ✅ Bottom player state
    const audioRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const [cur, setCur] = useState(0);
    const [dur, setDur] = useState(0);
    const [vol, setVol] = useState(0.85);



    const footerTitle = { fontSize: 18, fontWeight: 700, marginBottom: 12 };

    // ✅ active episode
    const activeEp = episodes?.[currentIndex] || null;




    // helpers (put above return)
    const fmtDate = (msOrIso) => {
        const ms = Number(msOrIso);
        const d = isFinite(ms) ? new Date(ms) : new Date(msOrIso);
        if (Number.isNaN(d.getTime())) return "";
        return d.toLocaleDateString(undefined, { weekday: "short", year: "numeric", month: "short", day: "numeric" });
    };

    const fmtMs = (msStr) => {
        const ms = Number(msStr);
        if (!isFinite(ms) || ms <= 0) return "0:00";
        const sec = Math.floor(ms / 1000);
        const h = Math.floor(sec / 3600);
        const m = Math.floor((sec % 3600) / 60);
        const s = sec % 60;
        if (h > 0) return `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
        return `${m}:${String(s).padStart(2, "0")}`;
    };

    // Read More state (put near your other useState)
    const [expandedIds, setExpandedIds] = useState(() => new Set());

    const toggleExpanded = (id) => {
        setExpandedIds((prev) => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    };


    // ✅ helper: time format
    const fmt = (s) => {
        if (!s || !isFinite(s)) return "0:00";
        const sec = Math.floor(s);
        const h = Math.floor(sec / 3600);
        const m = Math.floor((sec % 3600) / 60);
        const r = sec % 60;
        if (h > 0) return `${h}:${String(m).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
        return `${m}:${String(r).padStart(2, "0")}`;
    };

    // ✅ attach audio listeners ONCE


    const attachedRef = useRef(false);

    useEffect(() => {
        const a = audioRef.current;

        // if audio not mounted yet, do nothing (will run again next render)
        if (!a) return;

        // avoid double attaching
        if (attachedRef.current) return;
        attachedRef.current = true;

        const onLoaded = () => setDur(a.duration || 0);
        const onTime = () => setCur(a.currentTime || 0);
        const onPlay = () => setIsPlaying(true);
        const onPause = () => setIsPlaying(false);

        const onEnded = () => {
            setIsPlaying(false);
            setCurrentIndex((i) => {
                const next = i + 1;
                return next < episodes.length ? next : i;
            });
        };

        const onError = () => {
            console.log("AUDIO ERROR:", a.error);
            console.log("currentSrc:", a.currentSrc);
            setIsPlaying(false);
        };

        a.addEventListener("loadedmetadata", onLoaded);
        a.addEventListener("durationchange", onLoaded);
        a.addEventListener("timeupdate", onTime);
        a.addEventListener("play", onPlay);
        a.addEventListener("pause", onPause);
        a.addEventListener("ended", onEnded);
        a.addEventListener("error", onError);

        return () => {
            attachedRef.current = false;
            a.removeEventListener("loadedmetadata", onLoaded);
            a.removeEventListener("durationchange", onLoaded);
            a.removeEventListener("timeupdate", onTime);
            a.removeEventListener("play", onPlay);
            a.removeEventListener("pause", onPause);
            a.removeEventListener("ended", onEnded);
            a.removeEventListener("error", onError);
        };
        // IMPORTANT: include episodes.length so onEnded uses correct length
    }, [episodes.length]);


    // ✅ when episode changes, set src (NO fetch, so no CORS fetch problems)

    useEffect(() => {
        const a = audioRef.current;
        if (!a) return;

        if (!activeEp?.audioUrl) {
            a.pause();
            a.removeAttribute("src");
            a.load();
            setCur(0);
            setDur(0);
            setIsPlaying(false);
            return;
        }

        const wasPlaying = !a.paused;

        setCur(0);
        setDur(0);

        a.pause();
        a.currentTime = 0;

        a.src = activeEp.audioUrl;
        a.preload = "metadata";
        a.crossOrigin = "anonymous";
        a.volume = vol;
        a.load();

        if (wasPlaying || isPlaying) {
            const p = a.play();
            if (p?.catch) p.catch((e) => console.log("play() blocked:", e));
        }
    }, [activeEp?.audioUrl]); // ✅ important


    // ✅ keep volume synced
    useEffect(() => {
        const a = audioRef.current;
        if (!a) return;
        a.volume = vol;
    }, [vol]);

    // ✅ Play / Pause (must be called from a user click)
    const togglePlay = async () => {
        const a = audioRef.current;
        if (!a || !activeEp?.audioUrl) return;

        try {
            if (!a.src) {
                a.src = activeEp.audioUrl;
                a.preload = "metadata";
                a.crossOrigin = "anonymous";
                a.load();
            }

            if (a.paused) {
                await a.play(); // isPlaying updates by events
            } else {
                a.pause();
            }
        } catch (e) {
            console.log("togglePlay error:", e);
            setIsPlaying(false);
        }
    };

    // ✅ Play an episode from list
    const playEpisodeAtIndex = async (idx) => {
        if (idx < 0 || idx > episodes.length - 1) return;

        // same episode -> toggle
        if (idx === currentIndex) {
            togglePlay();
            return;
        }

        setCurrentIndex(idx);

        // next tick: play after src changed
        setTimeout(async () => {
            const a = audioRef.current;
            if (!a) return;
            try {
                await a.play();
            } catch (e) {
                console.log("playEpisodeAtIndex error:", e);
                setIsPlaying(false);
            }
        }, 0);
    };

    // ✅ Seek (slider 0..1000)
    const seekTo = (val) => {
        const a = audioRef.current;
        if (!a || !dur) return;

        const pct = Number(val) / 1000;
        const t = Math.max(0, Math.min(dur, pct * dur));
        a.currentTime = t;
        setCur(t);
    };

    const canPrev = currentIndex > 0;
    const canNext = currentIndex < episodes.length - 1;

    const goPrev = () => {
        if (!canPrev) return;
        playEpisodeAtIndex(currentIndex - 1);
    };

    const goNext = () => {
        if (!canNext) return;
        playEpisodeAtIndex(currentIndex + 1);
    };

    // ✅ spacer so footer/content doesn't hide behind fixed player
    const playerH = isMobile ? 208 : 245;


    ////////////////////

    // ✅ add this near top of component (once)
    const [latestExpanded, setLatestExpanded] = useState(false);




    ///////////////// Next 3 list 2

    const getPublishedTs = (ep) =>
        Number(ep?.publishedAtMs) ||
        (ep?.isoDate ? new Date(ep.isoDate).getTime() : 0) ||
        (ep?.pubDate ? new Date(ep.pubDate).getTime() : 0);

    const nextThree = useMemo(() => {
        if (!episodes?.length) return [];
        return [...episodes]
            .sort((a, b) => getPublishedTs(b) - getPublishedTs(a)) // newest-first
            .slice(1, 4); // skip the newest, take next 3
    }, [episodes]);



    ///////////// latest episodes


    const latestEp = useMemo(() => {
        if (!episodes?.length) return null;
        return [...episodes].sort((a, b) => getPublishedTs(b) - getPublishedTs(a))[0];
    }, [episodes]);

    const idxLatest = useMemo(() => {
        if (!latestEp) return -1;
        const latestKey = latestEp?.item_id || latestEp?.guid;
        return episodes.findIndex((x) => (x?.item_id || x?.guid) === latestKey);
    }, [episodes, latestEp]);







    return (
        <div
            style={{
                //  minHeight: "100dvh",
                backgroundColor: '#FFFFFF',
                //  marginTop: isMobile ? -5 : 0,
                boxSizing: "border-box",
                width: screenWidth,

                // ✅ equal white space all around + safe-area
                // paddingTop: `calc(${pagePad}px + env(safe-area-inset-top))`,
                //  paddingBottom: `calc(${pagePad}px + env(safe-area-inset-bottom))`,
                paddingLeft: `calc(${pagePad}px + env(safe-area-inset-left))`,
                paddingRight: `calc(${pagePad}px + env(safe-area-inset-right))`,

                display: "flex",
                justifyContent: 'flex-start',
                alignItems: "flex-start",
                flexDirection: 'column',
                paddingBottom: playerH,

            }}
        >



            <div style={{ width: screenWidth, display: "flex", justifyContent: "center", alignSelf: 'center', }}>

                {/* ✅ HERO CARD */}
                <div
                    ref={homeRef}
                    style={{
                        width: screenWidth, // "95%" on both (as you set)
                        minHeight: isMobile ? 0.34 * screenHeight : heroMinH, // ✅ fixes mobile white screen + desktop ratio height
                        height: "auto", // ✅ let it be driven by minHeight + content
                        // borderRadius: 22,
                        overflow: "hidden",
                        position: "relative",
                        background: "#FFFFFF",
                        //  background: "linear-gradient(180deg, #000000DB, #0000009F, #00000066, #00000033, )",
                        boxShadow: "0 18px 60px rgba(0,0,0,0.18)",
                    }}
                >
                    {/* ✅ Background image (absolute) */}

                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            height: "100%",
                            width: "100%",
                            backgroundImage: `url(${BG})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                            // ✅ focus the women on mobile
                            backgroundPosition: isMobile ? "85% center" : "center",
                            transform: isMobile ? "scale(1.0)" : "scale(1.02)",
                            filter: "saturate(1.05) contrast(1.05)",
                        }}
                    />


                    {/* ✅ overlay for text readability */}

                    {/* ✅ CONTENT (NOT absolute — so mobile height works) */}

                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            // background: "linear-gradient(90deg, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.42) 55%, rgba(0,0,0,0.22) 100%)",
                        }}
                    />

                    {/* ✅ CONTENT (NOT absolute — so mobile height works) */}
                    <div
                        style={{
                            position: "relative",
                            zIndex: 2,
                            padding: heroInset,
                            boxSizing: "border-box",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {/* TOP NAV */}
                        <div
                            style={{
                                height: headerRowH,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: scale(14),
                            }}
                        >
                            {/* Left: logo + hamburger */}
                            <div style={{ display: "flex", alignItems: "center", gap: scale(12) }}>
                                <div

                                    style={{
                                        width: isMobile ? 44 : 88,
                                        height: isMobile ? 44 : 88,
                                        borderRadius: 999,
                                        background: "rgba(255,255,255,0.08)",
                                        backdropFilter: "blur(10px)",
                                        display: "grid",
                                        placeItems: "center",
                                        border: "1px solid rgba(255,255,255,0.14)",
                                        overflow: "hidden",
                                        flexShrink: 0,
                                    }}
                                >
                                    <img
                                        src={LOGO}
                                        alt="Logo"
                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                    />
                                </div>

                                {isMobile ? (
                                    <div
                                        onClick={() => setMobileMenuOpen((v) => !v)}
                                        style={{
                                            width: 44,
                                            height: 44,
                                            borderRadius: 12,
                                            background: "rgba(0,0,0,0.28)",
                                            border: "1px solid rgba(255,255,255,0.14)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            userSelect: "none",
                                            backdropFilter: "blur(10px)",
                                        }}
                                    >
                                        <div style={{ display: "grid", gap: 5 }}>
                                            <div style={{ width: 18, height: 2, background: "rgba(255,255,255,0.9)", borderRadius: 99 }} />
                                            <div style={{ width: 18, height: 2, background: "rgba(255,255,255,0.9)", borderRadius: 99 }} />
                                            <div style={{ width: 18, height: 2, background: "rgba(255,255,255,0.9)", borderRadius: 99 }} />
                                        </div>
                                    </div>
                                ) : null}
                            </div>

                            {/* Center nav (desktop only) */}
                            {!isMobile ? (
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 28,
                                        padding: "6px",
                                        borderRadius: 999,
                                        background: "rgba(0,0,0,0.55)", // dark pill background
                                        backdropFilter: "blur(10px)",
                                        border: "1px solid rgba(255,255,255,0.15)",
                                        boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
                                        fontFamily: "Poppins",
                                    }}
                                >
                                    {navItems.map((t) => {
                                        let active = t === activeNav;
                                        if (t === "Home" && activeNav == null) active = true;

                                        return (
                                            <div
                                                key={t}
                                                onClick={() => setActiveNav(t)}
                                                style={{
                                                    padding: "4px 16px",
                                                    borderRadius: 999,
                                                    fontSize: 24,
                                                    fontWeight: 500,
                                                    cursor: "pointer",
                                                    userSelect: "none",
                                                    whiteSpace: "nowrap",

                                                    color: active ? "#E7EBF0" : "#FFFFFF",
                                                    background: active
                                                        ? "#FFFFFF33" // active inner pill
                                                        : "transparent",

                                                    transition: "all 0.2s ease",
                                                }}
                                                onMouseEnter={(e) => {
                                                    if (!active) e.currentTarget.style.background = "rgba(255,255,255,0.10)";
                                                }}
                                                onMouseLeave={(e) => {
                                                    if (!active) e.currentTarget.style.background = "transparent";
                                                }}
                                            >
                                                {t}
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div />
                            )}


                            {/* Membership */}

                            <button
                                onClick={() => setActiveNav("Contact")}
                                style={{
                                    border: "none",
                                    cursor: "pointer",

                                    height: isMobile ? 44 : 52,
                                    paddingLeft: isMobile ? 18 : 26,
                                    paddingRight: isMobile ? 22 : 30,

                                    borderRadius: 999, // ✅ full pill
                                    background: "#1F6F78", // teal like design
                                    color: "#FFFFFF",

                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: 10,

                                    fontSize: isMobile ? 15 : 18,
                                    fontWeight: 600,
                                    letterSpacing: 0.3,
                                    whiteSpace: "nowrap",

                                    fontFamily: "Poppins",
                                    boxShadow: "0 10px 26px rgba(0,0,0,0.22)",

                                    transition: "transform 0.15s ease, box-shadow 0.15s ease",
                                }}

                                onMouseDown={pressDown}
                                onMouseUp={pressUp}
                                onMouseEnter={hoverIn2}
                                onMouseLeave={hoverOut1}
                                onTouchStart={pressDown}
                                onTouchEnd={pressUp}
                            >
                                {/* Phone icon */}

                                <LuPhoneCall size={isMobile ? 18 : 22} color="#FFFFFF" />



                                Contact
                            </button>


                        </div>

                        {/* Mobile dropdown menu */}
                        {isMobile && mobileMenuOpen ? (
                            <div
                                style={{
                                    marginTop: 12,
                                    width: "92%",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    background: "rgba(0,0,0,0.45)",
                                    border: "1px solid rgba(255,255,255,0.14)",
                                    borderRadius: 16,
                                    padding: 10,
                                    backdropFilter: "blur(12px)",
                                    boxShadow: "0 18px 50px rgba(0,0,0,0.35)",
                                }}
                            >
                                {navItems.map((t) => (
                                    <div
                                        key={t}
                                        onClick={() => {
                                            setActiveNav(t);
                                            setMobileMenuOpen(false);
                                        }}
                                        style={{
                                            padding: "12px 12px",
                                            borderRadius: 12,
                                            color: "rgba(255,255,255,0.92)",
                                            fontWeight: 700,
                                            cursor: "pointer",
                                            fontSize: 16,
                                            background: t === activeNav ? "rgba(42,155,198,0.30)" : "transparent",
                                        }}
                                    >
                                        {t}
                                    </div>
                                ))}
                            </div>
                        ) : null}

                        {/* HERO BODY */}

                        {/* ✅ HERO BODY (REPLACE YOUR CURRENT HERO BODY WITH THIS) */}

                        {/* HERO BODY */}
                        <div
                            style={{
                                flex: 1,
                                display: "flex",
                                alignItems: isMobile ? "flex-start" : "center",
                                justifyContent: "flex-start",
                                paddingLeft: isMobile ? 0 : 35,
                                //  paddingRight: isMobile ? 0 : 18,
                                paddingTop: isMobile ? 18 : 10,
                                paddingBottom: isMobile ? 18 : 12,
                                boxSizing: "border-box",
                            }}
                        >
                            {/* Left fade overlay (to match design readability) */}
                            <div
                                style={{
                                    position: "absolute",
                                    inset: 0,
                                    pointerEvents: "none",
                                    background: isMobile ? "linear-gradient(90deg, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.52) 45%, rgba(0,0,0,0.18) 72%, rgba(0,0,0,0.00) 100%)" : null,
                                }}
                            />

                            {/* Content */}
                            <div
                                style={{
                                    position: "relative",
                                    zIndex: 3,
                                    width: "100%",
                                    maxWidth: isMobile ? "100%" : 980,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: isMobile ? 14 : 18,
                                    marginTop: isMobile ? 18 : 0,
                                    fontFamily: "Poppins",
                                    color: "#FFFFFF",
                                }}
                            >
                                {/* Headline */}
                                <div
                                    style={{
                                        fontSize: isMobile ? 34 : 54,
                                        lineHeight: isMobile ? "42px" : "76px",
                                        fontWeight: 400,
                                        letterSpacing: -0.6,
                                        textAlign: "left",
                                        maxWidth: isMobile ? "100%" : 820,
                                    }}
                                >
                                    “The Nurse and The Midwife”
                                    <br />
                                    <span style={{ fontWeight: 400 }}>hosted by </span>
                                    <span style={{ fontWeight: 900 }}>Marie and Grace</span>
                                </div>

                                {/* Sub text */}
                                <div
                                    style={{
                                        fontSize: isMobile ? 14 : 24,
                                        lineHeight: isMobile ? "22px" : "30px",
                                        fontWeight: 400,
                                        color: "rgba(255,255,255,0.88)",
                                        maxWidth: isMobile ? "100%" : 860,
                                        textAlign: "left",
                                        marginTop: isMobile ? 0 : 20
                                    }}
                                >
                                    Join us as we bring honest conversations from the front lines of healthcare and
                                    the front lines of our lives.
                                </div>

                                {/* Subscribe row */}


                                {/* Subscribe row */}
                                <div
                                    style={{
                                        marginTop: isMobile ? 6 : 20,
                                        display: "flex",
                                        alignItems: "center",
                                        flexWrap: "wrap",
                                        gap: isMobile ? 10 : 14,
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: isMobile ? 14 : 18,
                                            fontWeight: 600,
                                            color: "rgba(255,255,255,0.90)",
                                            marginRight: isMobile ? 6 : 10,
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        Subscribe on:
                                    </div>

                                    {[
                                        {
                                            key: "spotify",
                                            label: "Spotify",
                                            icon: <FaSpotify size={isMobile ? 20 : 22} color="#2EBD59" />,
                                        },
                                        {
                                            key: "apple",
                                            label: "Apple Podcasts",
                                            icon:
                                                <GrApple size={isMobile ? 18 : 20} color="#FFFFFF" />,
                                        },
                                        {
                                            key: "acast",
                                            label: "Acast",
                                            icon: <img
                                                src={acast1}
                                                alt="Logo"
                                                style={{ width: 18, height: 18, objectFit: "cover" }}
                                            />,
                                        },
                                    ].map((p) => (
                                        <button
                                            key={p.key}
                                            type="button"
                                            onClick={() => onSubscribeClick(p.key)}
                                            style={{
                                                border: "none",
                                                background: "transparent",
                                                padding: 0,
                                                cursor: "pointer",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    height: isMobile ? 40 : 46,
                                                    paddingLeft: isMobile ? 14 : 18,
                                                    paddingRight: isMobile ? 16 : 20,
                                                    borderRadius: 999,
                                                    background: "rgba(255,255,255,0.12)",
                                                    border: "1px solid rgba(255,255,255,0.16)",
                                                    backdropFilter: "blur(10px)",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: 10,
                                                    boxShadow: "0 10px 26px rgba(0,0,0,0.25)",
                                                    color: "rgba(255,255,255,0.92)",
                                                    fontSize: isMobile ? 14 : 16,
                                                    fontWeight: 600,
                                                    userSelect: "none",
                                                    transition: "transform 0.15s ease, background 0.15s ease",
                                                    whiteSpace: "nowrap",
                                                }}

                                                onMouseDown={pressDown}
                                                onMouseUp={pressUp}
                                                onMouseEnter={hoverIn}
                                                onMouseLeave={hoverOut}
                                                onTouchStart={pressDown}
                                                onTouchEnd={pressUp}     >
                                                {p.icon}
                                                <div>{p.label}</div>
                                            </div>
                                        </button>
                                    ))}
                                </div>



                            </div>
                        </div>




                        {isMobile ? <div style={{ height: 10 }} /> : null}
                    </div>

                </div>
            </div>

            {/* ✅ NEXT SECTION: LATEST (put this right after your HERO CARD block) */}
            <div

                ref={episodsRef}
                style={{
                    width: isMobile ? "95%" : Math.round(screenWidth * 0.94),
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: isMobile ? 26 : 44,
                    fontFamily: "Poppins",
                    // backgroundColor:'red'
                }}
            >

                {/* ===================== LATEST EPISODE ===================== */}
                {latestEp ? (
                    (() => {
                        const imgSrc = latestEp?.imageUrl || latestEp?.showImageUrl || "";
                        const title = latestEp?.title || "Untitled Episode";
                        const epNo = latestEp?.episodeNumber ?? latestEp?.generatedEpisodeNumber ?? "";
                        const dateText = latestEp?.publishedAtMs ? fmtDate(latestEp.publishedAtMs) : (latestEp?.pubDate || latestEp?.isoDate || "");
                        const durText = latestEp?.audioLength ? fmtMs(latestEp.audioLength) : "—";
                        const snippet = latestEp?.contentSnippet || "";

                        const isActive = idxLatest === currentIndex;
                        const isThisPlaying = isActive && isPlaying;

                        return (
                            <>
                                {/* Title */}
                                <div
                                    style={{
                                        textAlign: "center",
                                        fontSize: isMobile ? 34 : 54,
                                        fontWeight: "bolder",
                                        letterSpacing: -0.6,
                                        color: "#1F6F78",
                                        marginBottom: isMobile ? 16 : 22,
                                        fontFamily: "Poppins",
                                    }}
                                >
                                    Latest <span style={{ color: "#000000" }}>Episode</span>
                                </div>

                                {/* Card */}
                                <div
                                    style={{
                                        position: "relative",
                                        background: "#FFFFFF",
                                        borderRadius: isMobile ? 18 : 22,
                                        padding: isMobile ? 14 : 18,
                                        border: "2px solid rgba(15,23,42,0.10)",
                                        overflow: "hidden",
                                    }}
                                >
                                    <div
                                        style={{
                                            position: "relative",
                                            zIndex: 2,
                                            display: "flex",
                                            gap: isMobile ? 14 : 22,
                                            flexDirection: isMobile ? "column" : "row",
                                            alignItems: "stretch",
                                        }}
                                    >
                                        {/* IMAGE */}
                                        <div
                                            style={{
                                                flex: isMobile ? "unset" : "0 0 320px",
                                                height: isMobile ? 220 : 220,
                                                borderRadius: 14,
                                                overflow: "hidden",
                                                background: "#F1F5F9",
                                                border: "1px solid rgba(15,23,42,0.08)",
                                            }}
                                        >
                                            {imgSrc ? (
                                                <img
                                                    src={imgSrc}
                                                    alt={title}
                                                    style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                                                />
                                            ) : (
                                                <div
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        display: "grid",
                                                        placeItems: "center",
                                                        color: "rgba(15,23,42,0.45)",
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    No Image
                                                </div>
                                            )}
                                        </div>

                                        {/* CONTENT */}
                                        <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
                                            <div style={{ fontSize: isMobile ? 15 : 17, fontWeight: 600, color: "rgba(15,23,42,0.70)", marginBottom: 4, textAlign: "left" }}>
                                                Ep. {epNo}
                                            </div>

                                            <div style={{ fontSize: isMobile ? 20 : 26, lineHeight: isMobile ? "28px" : "34px", fontWeight: 700, color: "#1F6F78", letterSpacing: -0.3, textAlign: "left" }}>
                                                {title}
                                            </div>

                                            <div style={{ marginTop: 10, display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", fontSize: isMobile ? 13 : 15, color: "rgba(15,23,42,0.70)", fontWeight: 600, textAlign: "left" }}>
                                                <span>🕒 {durText || "—"}</span>
                                                <span style={{ opacity: 0.5 }}>|</span>
                                                <span>📅 {dateText || "—"}</span>
                                            </div>

                                            <div
                                                style={{
                                                    marginTop: 12,
                                                    fontSize: isMobile ? 14 : 17,
                                                    lineHeight: isMobile ? "22px" : "26px",
                                                    color: "rgba(15,23,42,0.78)",
                                                    fontWeight: 500,
                                                    maxWidth: 760,
                                                    textAlign: "left",
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    WebkitLineClamp: latestExpanded ? "unset" : 3,
                                                    overflow: "hidden",
                                                }}
                                            >
                                                {snippet || "—"}
                                            </div>

                                            {snippet?.length ? (
                                                <div
                                                    onClick={() => setLatestExpanded((v) => !v)}
                                                    style={{
                                                        marginTop: 10,
                                                        fontSize: isMobile ? 14 : 16,
                                                        fontWeight: 700,
                                                        color: "#1F6F78",
                                                        cursor: "pointer",
                                                        userSelect: "none",
                                                        whiteSpace: "nowrap",
                                                        textAlign: "left",
                                                        WebkitTapHighlightColor: "transparent",
                                                        WebkitUserSelect: "none",
                                                    }}
                                                >
                                                    {latestExpanded ? "Read Less" : "Read More"}
                                                </div>
                                            ) : null}
                                        </div>

                                        {/* PLAY */}
                                        <div style={{ display: "flex", alignItems: isMobile ? "flex-start" : "center", justifyContent: "center" }}>
                                            <button
                                                onClick={() => {
                                                    if (idxLatest >= 0) playEpisodeAtIndex(idxLatest);
                                                }}
                                                style={{
                                                    width: isMobile ? 56 : 66,
                                                    height: isMobile ? 56 : 66,
                                                    borderRadius: 999,
                                                    border: "none",
                                                    background: isThisPlaying ? "#0B5560" : "#1F6F78",
                                                    cursor: "pointer",
                                                    display: "grid",
                                                    placeItems: "center",
                                                    color: "white",
                                                    fontSize: 18,
                                                    fontWeight: 700,
                                                }}
                                                title={isThisPlaying ? "Pause" : "Play"}
                                            >
                                                {isThisPlaying ? "❚❚" : "▶"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        );
                    })()
                ) : null}

            </div>


            {/* ✅ MORE SECTION */}
            <div
                style={{
                    width: isMobile ? "95%" : Math.round(screenWidth * 0.94),
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: isMobile ? 36 : 60,
                    fontFamily: "Poppins",
                }}
            >
                {/* Title */}
                {episodes.length > 1 ? <div
                    style={{
                        textAlign: "center",
                        fontSize: isMobile ? 34 : 54,
                        fontWeight: 700,
                        letterSpacing: -0.6,
                        color: "#1F6F78",
                        marginBottom: isMobile ? 20 : 30,
                    }}
                >


                    More{" "}
                    <span style={{ color: "#000000" }}>
                        Episodes
                    </span>
                </div> : null}

                {/* LIST */}

                {/* ===================== NEXT 3 LATEST (BY publishedAtMs, EXCLUDING THE FIRST) ===================== */}
                <div style={{ display: "flex", flexDirection: "column", gap: isMobile ? 20 : 28 }}>
                    {nextThree.map((item, i) => {
                        const id = item?.item_id || item?.guid || `ep_${i}`;
                        const isExpanded = expandedIds.has(id);

                        const imgSrc = item?.imageUrl || item?.showImageUrl || "";
                        const title = item?.title || "Untitled Episode";
                        const epNo = item?.episodeNumber ?? item?.generatedEpisodeNumber ?? "";
                        const dateText = item?.publishedAtMs ? fmtDate(item.publishedAtMs) : (item?.pubDate || item?.isoDate || "");
                        const durText = item?.audioLength ? fmtMs(item.audioLength) : "—";
                        const snippet = item?.contentSnippet || "";

                        // ✅ real index inside ORIGINAL episodes array (for your current player logic)
                        const realIdx = episodes.findIndex(
                            (x) => (x?.item_id || x?.guid) === (item?.item_id || item?.guid)
                        );

                        const isActive = realIdx === currentIndex;
                        const isThisPlaying = isActive && isPlaying;

                        return (
                            <div
                                key={id}
                                style={{
                                    position: "relative",
                                    background: "#FFFFFF",
                                    borderRadius: isMobile ? 18 : 22,
                                    padding: isMobile ? 14 : 18,
                                    border: "2px solid rgba(15,23,42,0.10)",
                                    overflow: "hidden",
                                }}
                            >
                                <div
                                    style={{
                                        position: "relative",
                                        zIndex: 2,
                                        display: "flex",
                                        gap: isMobile ? 14 : 22,
                                        flexDirection: isMobile ? "column" : "row",
                                    }}
                                >
                                    {/* IMAGE */}
                                    <div
                                        style={{
                                            flex: isMobile ? "unset" : "0 0 280px",
                                            height: isMobile ? 200 : 220,
                                            borderRadius: 14,
                                            overflow: "hidden",
                                            background: "#F1F5F9",
                                            border: "1px solid rgba(15,23,42,0.08)",
                                        }}
                                    >
                                        {imgSrc ? (
                                            <img
                                                src={imgSrc}
                                                alt={title}
                                                style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                                            />
                                        ) : (
                                            <div
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    display: "grid",
                                                    placeItems: "center",
                                                    color: "rgba(15,23,42,0.45)",
                                                    fontWeight: 700,
                                                }}
                                            >
                                                No Image
                                            </div>
                                        )}
                                    </div>

                                    {/* CONTENT */}
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ fontSize: isMobile ? 15 : 17, fontWeight: 600, color: "rgba(15,23,42,0.70)", marginBottom: 4, textAlign: "left" }}>
                                            Ep. {epNo}
                                        </div>

                                        <div style={{ fontSize: isMobile ? 20 : 26, lineHeight: isMobile ? "28px" : "34px", fontWeight: 700, color: "#1F6F78", letterSpacing: -0.3, textAlign: "left" }}>
                                            {title}
                                        </div>

                                        <div style={{ marginTop: 10, display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", fontSize: isMobile ? 13 : 15, color: "rgba(15,23,42,0.70)", fontWeight: 600, textAlign: "left" }}>
                                            <span>🕒 {durText}</span>
                                            <span style={{ opacity: 0.5 }}>|</span>
                                            <span>📅 {dateText || "—"}</span>
                                        </div>

                                        {/* SNIPPET */}
                                        <div
                                            style={{
                                                marginTop: 12,
                                                fontSize: isMobile ? 14 : 17,
                                                lineHeight: isMobile ? "22px" : "26px",
                                                color: "rgba(15,23,42,0.78)",
                                                fontWeight: 500,
                                                maxWidth: 760,
                                                textAlign: "left",
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                WebkitLineClamp: isExpanded ? "unset" : 3,
                                                overflow: "hidden",
                                            }}
                                        >
                                            {snippet || "—"}
                                        </div>

                                        {snippet?.length ? (
                                            <div
                                                onClick={() => toggleExpanded(id)}
                                                style={{
                                                    marginTop: 10,
                                                    fontSize: isMobile ? 14 : 16,
                                                    fontWeight: 700,
                                                    color: "#1F6F78",
                                                    cursor: "pointer",
                                                    textAlign: "left",
                                                    userSelect: "none",
                                                    WebkitTapHighlightColor: "transparent",
                                                    WebkitUserSelect: "none",
                                                }}
                                            >
                                                {isExpanded ? "Read Less" : "Read More"}
                                            </div>
                                        ) : null}
                                    </div>

                                    {/* PLAY */}
                                    <div style={{ display: "flex", alignItems: isMobile ? "flex-start" : "center", justifyContent: "center" }}>
                                        <button
                                            onClick={() => {
                                                if (realIdx >= 0) playEpisodeAtIndex(realIdx);
                                            }}
                                            style={{
                                                width: isMobile ? 56 : 66,
                                                height: isMobile ? 56 : 66,
                                                borderRadius: 999,
                                                border: "none",
                                                background: isThisPlaying ? "#0B5560" : "#1F6F78",
                                                cursor: "pointer",
                                                display: "grid",
                                                placeItems: "center",
                                                color: "white",
                                                fontSize: 18,
                                                fontWeight: 700,
                                            }}
                                            title={isThisPlaying ? "Pause" : "Play"}
                                        >
                                            {isThisPlaying ? "❚❚" : "▶"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>


            </div>






            <div
                style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: isMobile ? 14 : 18,
                    fontFamily: "Poppins",
                }}
            >
                <button
                    onClick={() => navigate("/All_episod", { state: { episodes } })}


                    style={{
                        border: "none",
                        background: "transparent",
                        color: "#1F6F78",
                        cursor: "pointer",
                        fontSize: isMobile ? 14 : 16,
                        fontWeight: 600,
                        padding: "6px 4px",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                        letterSpacing: 0.2,
                        fontFamily: "sans-serif"
                    }}

                    onMouseDown={pressDown}
                    onMouseUp={pressUp}
                    onMouseEnter={hoverIn1}
                    onMouseLeave={hoverOut}
                    onTouchStart={pressDown}
                    onTouchEnd={pressUp}

                >
                    {"View All Episodes"}


                    <FaArrowRightLong color="#1F6F78" />
                </button>
            </div>


            {/* ✅ MEET OUR HOSTS */}
            <div

                ref={hostRef}
                style={{
                    width: isMobile ? "95%" : screenWidth * 0.94,
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: isMobile ? 48 : 72,
                    marginBottom: isMobile ? 48 : 72,
                    textAlign: "center",
                    fontFamily: "Poppins",
                }}
            >
                {/* Title */}
                <div
                    style={{
                        fontSize: isMobile ? 34 : 54,
                        fontWeight: "bolder",
                        letterSpacing: -0.6,
                        color: "#111827",
                        lineHeight: isMobile ? "34px" : "52px",
                    }}
                >
                    Meet Our{" "}
                    <span style={{ color: "#1F6F78" }}>
                        Hosts
                    </span>
                </div>

                {/* Description */}
                <div
                    style={{
                        marginTop: isMobile ? 14 : 18,
                        maxWidth: 900,
                        marginLeft: "auto",
                        marginRight: "auto",
                        fontSize: isMobile ? 14.5 : 18,
                        lineHeight: isMobile ? "22px" : "30px",
                        color: "#4B5563",
                        fontWeight: 400,
                    }}
                >
                    Meet Marie and Grace, a nurse and midwife who struck up an amazing friendship
                    following their introduction 5 years ago! Both work for the NHS and are
                    navigating their way through motherhood together.
                </div>
            </div>

            {/* ✅ MEET OUR HOSTS (NEXT SECTION BELOW EPISODES) */}
            <div
                style={{
                    width: isMobile ? "95%" : Math.round(screenWidth * 0.94),
                    marginLeft: "auto",
                    marginRight: "auto",

                    fontFamily: "Poppins",
                }}
            >


                {/* Cards */}
                <div style={{ display: "grid", gap: isMobile ? 18 : 26 }}>

                    <div

                        style={{
                            position: "relative",
                            borderRadius: isMobile ? 18 : 22,
                            overflow: "hidden",
                            background: "#FFFFFF",
                            border: "1px solid rgba(15,23,42,0.10)",
                            boxShadow: "0 26px 70px rgba(0,0,0,0.18)",
                        }}
                    >
                        {/* teal glow base (like screenshot shadow) */}
                        <div
                            style={{
                                position: "absolute",
                                left: 16,
                                right: 16,
                                bottom: -22,
                                height: 64,
                                background: "#1F6F78",
                                filter: "blur(18px)",
                                opacity: 0.55,
                                borderRadius: 999,

                            }}
                        />

                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: isMobile ? "1fr" : "0.95fr 1.35fr",
                                alignItems: "stretch",
                                position: "relative",
                                zIndex: 2,
                                //  backgroundColor:'red'
                            }}
                        >
                            {/* LEFT IMAGE */}

                            {/* LEFT IMAGE */}

                            {/* LEFT IMAGE */}
                            <div
                                style={{
                                    width: "100%",
                                    overflow: "hidden",

                                    // ✅ break out of centered layout on mobile
                                    marginLeft: 0,
                                    marginRight: 0,

                                    background: "linear-gradient(180deg, #E9F7F7, #DFF2F2)",
                                }}
                            >
                                <div
                                    style={{
                                        width: "100%",
                                        height: isMobile ? 420 : "100%",
                                        minHeight: isMobile ? 420 : 746,

                                        backgroundImage: `url(${host1})`,
                                        backgroundRepeat: "no-repeat",

                                        // ✅ keep full coverage without side gaps
                                        backgroundSize: "cover",

                                        // ✅ focus on face
                                        backgroundPosition: "center top",

                                        display: "block",
                                    }}
                                />
                            </div>

                            {/* RIGHT CONTENT (full height like left side) */}
                            <div
                                style={{
                                    background: "#FFFFFF",
                                    padding: isMobile ? "18px 16px" : "30px 34px",
                                    height: "100%",                 // ✅ take full height of grid row
                                    minHeight: isMobile ? "auto" : 540, // ✅ keeps desktop tall like design (match left minHeight)
                                    display: "flex",
                                    flexDirection: "column",         // ✅ allows bottom pin
                                    justifyContent: "space-between", // ✅ tags can sit at bottom
                                    boxSizing: "border-box",
                                }}
                            >
                                {/* TOP: header row */}
                                <div>
                                    <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
                                        {/* icon circle */}
                                        <div
                                            style={{
                                                width: isMobile ? 54 : 66,
                                                height: isMobile ? 54 : 66,
                                                borderRadius: 999,
                                                background: "#1F6F78",
                                                display: "grid",
                                                placeItems: "center",
                                                boxShadow: "0 14px 34px rgba(0,0,0,0.20)",
                                                flexShrink: 0,
                                            }}
                                        >
                                            <RiNurseFill size={isMobile ? 25 : 30} color="#E7EBF0" />

                                        </div>

                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            <div
                                                style={{
                                                    fontSize: isMobile ? 34 : 46,
                                                    lineHeight: isMobile ? "38px" : "50px",
                                                    fontWeight: 900,
                                                    color: "#0B1220",
                                                    letterSpacing: -0.6,
                                                    fontFamily: "Poppins",
                                                }}
                                            >
                                                Marie
                                            </div>

                                            <div
                                                style={{
                                                    marginTop: 2,
                                                    fontSize: isMobile ? 16 : 18,
                                                    fontWeight: 900,
                                                    color: "#1F6F78",
                                                    fontFamily: "Poppins",
                                                    textAlign: 'left'
                                                }}
                                            >
                                                The Nurse
                                            </div>
                                        </div>
                                    </div>

                                    {/* MIDDLE: paragraphs */}
                                    <div
                                        style={{
                                            marginTop: isMobile ? 16 : 20,
                                            display: "grid",
                                            gap: isMobile ? 14 : 18,
                                        }}
                                    >


                                        <div
                                            style={{
                                                fontSize: isMobile ? 14.5 : 20,
                                                lineHeight: isMobile ? "22px" : "30px",
                                                color: "#374151",
                                                fontWeight: 400,
                                                fontFamily: "Poppins",
                                                textAlign: "left",
                                                marginTop: isMobile ? 0 : 15
                                            }}
                                        >
                                            <span style={{ fontWeight: 700 }}>Marie ‘The Nurse’ qualified as a Registered Nurse (Adult)</span> in 2003. She has worked in both NHS and private settings and even experienced working as a nurse in Australia, during her year backpacking.

                                        </div>

                                        <div
                                            style={{
                                                fontSize: isMobile ? 14.5 : 20,
                                                lineHeight: isMobile ? "22px" : "30px",
                                                color: "#374151",
                                                fontWeight: 400,
                                                fontFamily: "Poppins",
                                                textAlign: "left",

                                                marginTop: isMobile ? 0 : 15
                                            }}
                                        >
                                            Marie’s most recent post in the NHS was as a <span style={{ fontWeight: 700 }}>Clinical Nurse Specialist in the Acute Pain Management team.</span> This area of practice really interested Marie following her experience working in the surgical high dependency unit, looking after patients that had complex and high risk surgeries.

                                        </div>


                                        <div
                                            style={{
                                                fontSize: isMobile ? 14.5 : 20,
                                                lineHeight: isMobile ? "22px" : "30px",
                                                color: "#374151",
                                                fontWeight: 400,
                                                fontFamily: "Poppins",
                                                textAlign: "left",

                                                marginTop: isMobile ? 0 : 15
                                            }}
                                        >
                                            Marie has also trained as a <span style={{ fontWeight: 700 }}>Clinical Hypnotherapist,</span> working with people requiring help with a variety of conditions. Subsequently she went on to train as a <span style={{ fontWeight: 700 }}>Hypnobirthing teacher</span> having discovered the value of relaxation and effective antenatal education in promoting a mindful birth.

                                        </div>


                                    </div>
                                </div>

                                {/* BOTTOM: tags pinned */}
                                <div
                                    style={{
                                        marginTop: isMobile ? 18 : 22,
                                        display: "flex",
                                        gap: 12,
                                        flexWrap: "wrap",
                                        alignItems: "center",
                                    }}
                                >
                                    {["Registered Nurse", "Clinical Specialist", "Hypnobirthing Teacher"].map((t) => (
                                        <div
                                            key={t}
                                            style={{
                                                padding: isMobile ? "10px 14px" : "12px 18px",
                                                borderRadius: 999,
                                                background: "#1F6F78",
                                                color: "#FFFFFF",
                                                fontWeight: 800,
                                                fontSize: isMobile ? 13 : 15,
                                                border: "1px solid rgba(27,124,134,0.18)",
                                                whiteSpace: "nowrap",
                                                fontFamily: "Poppins",
                                            }}
                                        >
                                            {t}
                                        </div>
                                    ))}
                                </div>
                            </div>


                        </div>
                    </div>

                </div>
            </div>

            {/* ✅ HOST CARD: GRACE (Text LEFT, Image RIGHT) */}
            <div
                style={{
                    width: isMobile ? "95%" : Math.round(screenWidth * 0.94),
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: isMobile ? 18 : 26,
                    borderRadius: 22,
                    overflow: "hidden",
                    background: "#FFFFFF",
                    border: "1px solid rgba(0,0,0,0.06)",
                    boxShadow: "0 18px 60px rgba(0,0,0,0.12)",
                    position: "relative",
                }}
            >
                {/* bottom teal glow like design */}
                <div
                    style={{
                        position: "absolute",
                        left: 0,
                        right: 0,
                        bottom: 0,
                        height: 92,
                        background: "#0F6E73",
                        opacity: 0.9,
                    }}
                />

                <div
                    style={{
                        position: "relative",
                        zIndex: 2,
                        display: "grid",
                        gridTemplateColumns: isMobile ? "1fr" : "1.35fr 0.95fr",
                        minHeight: isMobile ? "auto" : 540,
                        background: "#FFFFFF",
                    }}
                >
                    {/* LEFT CONTENT (TEXT) */}
                    <div
                        style={{
                            padding: isMobile ? "18px 16px 18px" : "28px 30px 24px",
                            background: "#FFFFFF",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            gap: isMobile ? 16 : 10,
                        }}
                    >
                        {/* header row */}
                        <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
                            {/* icon circle */}
                            <div
                                style={{
                                    width: isMobile ? 54 : 66,
                                    height: isMobile ? 54 : 66,
                                    borderRadius: 999,
                                    background: "linear-gradient(180deg, #FF6B7A, #E43B51)",
                                    display: "grid",
                                    placeItems: "center",
                                    boxShadow: "0 14px 34px rgba(0,0,0,0.18)",
                                    flexShrink: 0,
                                }}
                            >
                                {/* heart icon */}

                                <LuHeartPulse size={isMobile ? 25 : 30} color="#FFFFFF" />


                            </div>

                            <div>
                                <div
                                    style={{
                                        fontSize: isMobile ? 34 : 46,
                                        lineHeight: isMobile ? "38px" : "50px",
                                        fontWeight: 900,
                                        color: "#0B1220",
                                        letterSpacing: -0.6,
                                        fontFamily: "Poppins",
                                    }}
                                >
                                    Grace
                                </div>
                                <div
                                    style={{
                                        marginTop: 2,
                                        fontSize: isMobile ? 16 : 18,
                                        fontWeight: 800,
                                        color: "linear-gradient(180deg, #FF6B7A, #E43B51)",
                                        fontFamily: "Poppins",
                                        textAlign: 'left'
                                    }}
                                >
                                    'The Midwife'
                                </div>
                            </div>
                        </div>

                        {/* paragraphs */}

                        <div
                            style={{
                                marginTop: isMobile ? 16 : 20,
                                display: "grid",
                                gap: isMobile ? 19 : 35,
                            }}
                        >


                            <div
                                style={{
                                    fontSize: isMobile ? 14.5 : 20,
                                    lineHeight: isMobile ? "22px" : "30px",
                                    color: "#374151",
                                    fontWeight: 400,
                                    fontFamily: "Poppins",
                                    textAlign: "left",

                                }}
                            >
                                <span style={{ fontWeight: 700 }}>Grace, ‘the midwife’ qualified in 2021,</span> after 5 years of training. What should have been a 3 year course was extended by a baby thrown into the mix, covid.

                            </div>

                            <div
                                style={{
                                    fontSize: isMobile ? 14.5 : 20,
                                    lineHeight: isMobile ? "22px" : "30px",
                                    color: "#374151",
                                    fontWeight: 400,
                                    fontFamily: "Poppins",
                                    textAlign: "left",


                                }}
                            >
                                Grace currently works as a <span style={{ fontWeight: 700 }}>rotational midwife</span> at her local NHS trust, primarily splitting her time between the antenatal ward and delivery suite.

                            </div>


                            <div
                                style={{
                                    fontSize: isMobile ? 14.5 : 20,
                                    lineHeight: isMobile ? "22px" : "30px",
                                    color: "#374151",
                                    fontWeight: 400,
                                    fontFamily: "Poppins",
                                    textAlign: "left",


                                }}
                            >
                                Grace has developed a deep passion for <span style={{ fontWeight: 700 }}>labour and birth education,</span> and for supporting women and families to feel informed, confident, and empowered during one of the most important experiences of their lives. I’ve witnessed first hand how knowledge, preparation, and compassionate care can transform the birth experience — and how fear and misinformation can take that power away.

                            </div>


                        </div>

                        {/* tags */}
                        <div
                            style={{
                                display: "flex",
                                gap: 12,
                                flexWrap: "wrap",
                                marginTop: 6,
                            }}
                        >
                            {["Qualified Midwife", "NHS Trust", "Birth Educator", "Mother"].map((t) => (
                                <div
                                    key={t}
                                    style={{
                                        padding: "9px 14px",
                                        borderRadius: 999,
                                        background: "linear-gradient(180deg, #FF6B7A, #E43B51)",
                                        color: "#FFFFFF",
                                        fontWeight: 800,
                                        fontSize: isMobile ? 13 : 15,
                                        border: "1px solid rgba(228,59,81,0.16)",
                                        whiteSpace: "nowrap",
                                        fontFamily: "Poppins",
                                    }}
                                >
                                    {t}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* RIGHT IMAGE (covers full height) */}
                    <div
                        style={{
                            width: "100%",
                            height: isMobile ? 380 : "100%",
                            minHeight: isMobile ? 380 : 540,
                            background: "linear-gradient(180deg, #EAF6F6, #E3F2F2)",
                            display: "flex",
                            alignItems: "stretch",
                            justifyContent: "stretch",
                            overflow: "hidden",
                        }}
                    >
                        <img
                            src={host2}   // ✅ your uploaded grace image import/variable
                            alt="Grace"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: isMobile ? "contain" : "cover", // mobile shows full (no crop), desktop looks like screenshot
                                objectPosition: "center",
                                display: "block",
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* ✅ OUR MISSION (NEXT SECTION BELOW HOSTS) */}
            <div

                ref={missiontRef}
                style={{
                    width: isMobile ? "95%" : screenWidth * 0.94,
                    alignSelf: "center",
                    marginTop: isMobile ? 26 : 34,
                    marginBottom: isMobile ? 10 : 18,
                }}
            >
                <div
                    style={{
                        width: "100%",
                        borderRadius: isMobile ? 18 : 22,
                        overflow: "hidden",
                        position: "relative",
                        boxShadow: "0 22px 70px rgba(0,0,0,0.22)",
                        background: "#1F6F78",
                        minHeight: isMobile ? 400 : 594,
                    }}
                >




                    {/* Content */}
                    <div
                        style={{
                            position: "relative",
                            zIndex: 2,
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: isMobile ? "26px 18px" : "34px 26px",
                            boxSizing: "border-box",
                        }}
                    >
                        <div
                            style={{
                                width: "100%",
                                maxWidth: 980,
                                textAlign: "center",
                                color: "#FFFFFF",
                                fontFamily: "Poppins",
                            }}
                        >
                            {/* Title row */}
                            <div
                                style={{
                                    display: "flex",
                                    gap: 14,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginBottom: isMobile ? 14 : 18,
                                }}
                            >
                                {/* Headphones icon */}


                                <IoHeadsetOutline size={isMobile ? 21 : 42} color="#E7EBF0" />

                                <div
                                    style={{
                                        fontSize: isMobile ? 25 : 54,
                                        lineHeight: isMobile ? "34px" : "52px",
                                        fontWeight: 800,
                                        letterSpacing: -0.8,
                                    }}
                                >
                                    Our{" "}
                                    <span style={{ color: "#19B7B0" }}>
                                        Mission
                                    </span>{" "}
                                    Together
                                </div>
                            </div>

                            {/* Paragraphs */}
                            <div
                                style={{
                                    fontSize: isMobile ? 12 : 22,
                                    lineHeight: isMobile ? "20px" : "32px",
                                    fontWeight: 500,
                                    color: "#FFFFFF",
                                    marginBottom: isMobile ? 18 : 18,
                                    marginTop: isMobile ? 20 : 50
                                }}
                            >
                                We've witnessed first hand how knowledge, preparation, and compassionate care can transform the birth
                                experience, and how fear and misinformation can take that power away.
                            </div>

                            <div
                                style={{
                                    fontSize: isMobile ? 12 : 22,
                                    lineHeight: isMobile ? "20px" : "32px",
                                    fontWeight: 500,
                                    color: "#FFFFFF",
                                    marginBottom: isMobile ? 18 : 18,
                                    marginTop: isMobile ? 5 : 15,
                                }}
                            >
                                This podcast was created to bridge that gap. We want to offer honest, evidence-based conversations about
                                labour and birth, explained in a way that’s clear, practical, and free from judgement. Our goal is to
                                demystify birth, share real experiences, and provide education that helps families understand their
                                choices, trust their bodies, and feel supported every step of the way, whether it’s their first birth or
                                their fourth.
                            </div>

                            <div
                                style={{
                                    fontSize: isMobile ? 12 : 22,
                                    lineHeight: isMobile ? "20px" : "32px",
                                    fontWeight: 500,
                                    color: "#FFFFFF",
                                }}
                            >
                                Combining this with divulging into our personal lives, motherhood, friendship, life’s ups and down…
                                we’ve got it all covered. So come and join us for a bit of craic!
                            </div>
                        </div>
                    </div>


                </div>
            </div>


            {/* ✅ GET INVOLVED SECTION (AFTER HERO CARD) */}
            <div


                ref={ConcactRef}
                style={{
                    width: isMobile ? "95%" : screenWidth * 0.94,
                    alignSelf: "center",
                    marginTop: isMobile ? 26 : 40,
                    marginBottom: isMobile ? 26 : 44,
                    borderRadius: isMobile ? 18 : 22,
                    overflow: "hidden",
                    boxShadow: "0 18px 60px rgba(0,0,0,0.18)",
                    display: "grid",
                    gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                    background: "#FFFFFF",
                }}
            >
                {/* LEFT: FORM PANEL */}
                <div
                    style={{
                        background: "#1F6F78",
                        padding: isMobile ? "22px 18px" : "42px 46px",
                        color: "#FFFFFF",
                        justifyContent: 'center',
                        // alignContent:'center'
                    }}
                >
                    <div
                        style={{
                            fontFamily: "Poppins",
                            fontWeight: 800,
                            fontSize: isMobile ? 34 : 54,
                            lineHeight: isMobile ? "40px" : "60px",
                            letterSpacing: -0.6,
                            marginBottom: isMobile ? 16 : 24,
                            textAlign: 'left'
                        }}
                    >
                        Get Involved
                    </div>

                    {/* 2 inputs row */}
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                            gap: isMobile ? 14 : 18,
                            marginBottom: isMobile ? 14 : 18,
                            marginTop: isMobile ? 0 : 30
                        }}
                    >
                        <div>
                            <div
                                style={{
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                    fontSize: 16,
                                    marginBottom: 8,
                                    opacity: 0.95,
                                    textAlign: 'left'
                                }}
                            >
                                First name
                            </div>
                            <input
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                placeholder="First name"
                                style={{
                                    width: "100%",
                                    height: 46,
                                    borderRadius: 8,
                                    border: "1px solid rgba(0,0,0,0.10)",
                                    padding: "0 14px",
                                    fontFamily: "Poppins",
                                    fontSize: 16,
                                    outline: "none",
                                    background: "#FFFFFF",
                                    color: "#0B1220",
                                    boxSizing: "border-box",
                                }}
                            />
                        </div>

                        <div>
                            <div
                                style={{
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                    fontSize: 16,
                                    marginBottom: 8,
                                    opacity: 0.95,
                                    textAlign: 'left'
                                }}
                            >
                                Last name
                            </div>
                            <input
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                placeholder="Last name"
                                style={{
                                    width: "100%",
                                    height: 46,
                                    borderRadius: 8,
                                    border: "1px solid rgba(0,0,0,0.10)",
                                    padding: "0 14px",
                                    fontFamily: "Poppins",
                                    fontSize: 16,
                                    outline: "none",
                                    background: "#FFFFFF",
                                    color: "#0B1220",
                                    boxSizing: "border-box",
                                }}
                            />
                        </div>
                    </div>

                    {/* Email */}
                    <div style={{ marginBottom: isMobile ? 18 : 22 }}>
                        <div
                            style={{
                                fontFamily: "Poppins",
                                fontWeight: 700,
                                fontSize: 16,
                                marginBottom: 8,
                                opacity: 0.95,
                                textAlign: 'left'
                            }}
                        >
                            Email
                        </div>
                        <input
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="you@company.com"
                            style={{
                                width: "100%",
                                height: 46,
                                borderRadius: 8,
                                border: "1px solid rgba(0,0,0,0.10)",
                                padding: "0 14px",
                                fontFamily: "Poppins",
                                fontSize: 16,
                                outline: "none",
                                background: "#FFFFFF",
                                color: "#0B1220",
                                boxSizing: "border-box",
                            }}
                        />
                    </div>

                    {/* Email */}

                    <div style={{ marginBottom: isMobile ? 18 : 22 }}>
                        <div
                            style={{
                                fontFamily: "Poppins",
                                fontWeight: 700,
                                fontSize: 16,
                                marginBottom: 8,
                                opacity: 0.95,
                                textAlign: "left",
                            }}
                        >
                            Comments
                        </div>

                        <textarea
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder="Your comments here "
                            rows={isMobile ? 2 : 4}   // ✅ controls visible lines
                            style={{
                                width: "100%",
                                height: isMobile ? 46 : 80, // keeps your layout intact
                                borderRadius: 8,
                                border: "1px solid rgba(0,0,0,0.10)",
                                padding: "10px 14px",
                                fontFamily: "Poppins",
                                fontSize: 16,
                                outline: "none",
                                background: "#FFFFFF",
                                color: "#0B1220",
                                boxSizing: "border-box",

                                resize: "none",        // ✅ prevents ugly resize handle
                                lineHeight: "22px",    // ✅ clean multi-line spacing
                            }}
                        />
                    </div>


                    {/* Submit */}
                    <button
                        onClick={onSubmitGetInvolved}
                        style={{
                            width: isMobile ? "100%" : 460,
                            maxWidth: "100%",
                            height: isMobile ? 54 : 62,
                            borderRadius: 999,
                            border: "none",
                            background: "rgba(255,255,255,0.16)",
                            color: "#FFFFFF",
                            fontFamily: "Poppins",
                            fontWeight: 800,
                            fontSize: isMobile ? 18 : 22,
                            cursor: "pointer",
                            boxShadow: "0 18px 40px rgba(0,0,0,0.28)",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: 6,
                        }}


                        onMouseDown={pressDown}
                        onMouseUp={pressUp}
                        onMouseEnter={hoverIn1}
                        onMouseLeave={hoverOut2}
                        onTouchStart={pressDown}
                        onTouchEnd={pressUp}
                    >
                        Submit
                    </button>
                </div>

                {/* RIGHT: IMAGE PANEL */}
                <div
                    style={{
                        position: "relative",
                        minHeight: isMobile ? 260 : 646,
                        background: "#EAF4F4",
                        overflow: "hidden",
                    }}
                >
                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            backgroundImage: `url(${clinic})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            transform: "scale(1.02)",
                            filter: "saturate(1.05) contrast(1.03)",
                        }}
                    />
                    {/* subtle overlay like screenshot */}
                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            background:
                                "linear-gradient(90deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.06) 100%)",
                        }}
                    />
                </div>
            </div>


            {/* ===================== STORIES SECTION ===================== */}
            <div
                style={{
                    width: isMobile ? "95%" : screenWidth * 0.94,
                    alignSelf: "center",
                    marginTop: isMobile ? 20 : 20,
                    marginBottom: isMobile ? 40 : 80,
                    textAlign: "center",
                }}
            >
                {/* Title: Tune Into the Stories */}
                <div
                    style={{
                        fontFamily: "Poppins",
                        fontWeight: 900,
                        fontSize: isMobile ? 34 : 54,
                        letterSpacing: -0.8,
                        color: "#0B1220",
                        marginBottom: isMobile ? 10 : 12,
                    }}
                >
                    Tune Into the{" "}
                    <span style={{ color: "#1F6F78" }}>
                        Stories
                    </span>
                </div>

                {/* Subtitle */}
                <div
                    style={{
                        maxWidth: 860,
                        margin: "0 auto",
                        fontFamily: "Poppins",
                        fontSize: isMobile ? 14.5 : 18,
                        lineHeight: isMobile ? "22px" : "28px",
                        color: "rgba(11,18,32,0.72)",
                        marginBottom: isMobile ? 24 : 30,
                    }}
                >
                    From sky-high rescues to hospital hallways, every episode dives deep into
                    the lives of people turning the ordinary into the extraordinary.
                </div>

                {/* Podcasts heading */}
                <div
                    style={{
                        fontFamily: "Poppins",
                        fontWeight: 700,
                        fontSize: isMobile ? 30 : 44,
                        color: "#0B1220",
                        marginBottom: isMobile ? 22 : 30,
                    }}
                >
                    Podcasts
                </div>

                {/* Platforms */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
                        gap: isMobile ? 16 : 0,
                        alignItems: "center",
                        justifyItems: "center",
                    }}
                >
                    {/* Spotify */}
                    <a
                        href="https://open.spotify.com/"
                        target="_blank"
                        rel="noreferrer"
                        style={{
                            // width: "100%",
                            // maxWidth: 280,
                            //   height: 86,
                            paddingLeft: 45,
                            paddingRight: 45,
                            paddingTop: 27,
                            paddingBottom: 27,
                            background: "#FFFFFF",
                            borderRadius: 10,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textDecoration: "none",
                            border: "1px solid rgba(11,18,32,0.10)",
                            boxShadow: "0 10px 24px rgba(0,0,0,0.12)",
                            color: '#000000',
                            gap: 10,
                            fontSize: isMobile ? 20 : 22,
                            fontFamily: 'Poppins'


                        }}

                        onMouseDown={pressDown}
                        onMouseUp={pressUp}
                        onMouseEnter={hoverIn1}
                        onMouseLeave={hoverOut}
                        onTouchStart={pressDown}
                        onTouchEnd={pressUp}
                    >

                        <FaSpotify size={isMobile ? 30 : 32} color="#2EBD59" />
                        Spotify
                    </a>

                    {/* Apple Podcasts */}

                    <a
                        href="https://podcasts.apple.com/"
                        target="_blank"
                        rel="noreferrer"
                        style={{
                            // width: "100%",
                            // maxWidth: 280,
                            //   height: 86,
                            paddingLeft: 35,
                            paddingRight: 35,
                            paddingTop: 27,
                            paddingBottom: 27,
                            background: "#FFFFFF",
                            borderRadius: 10,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textDecoration: "none",
                            border: "1px solid rgba(11,18,32,0.10)",
                            boxShadow: "0 10px 24px rgba(0,0,0,0.12)",
                            color: '#000000',
                            gap: 10,
                            fontSize: isMobile ? 20 : 22,
                            fontFamily: 'Poppins'


                        }}

                        onMouseDown={pressDown}
                        onMouseUp={pressUp}
                        onMouseEnter={hoverIn1}
                        onMouseLeave={hoverOut}
                        onTouchStart={pressDown}
                        onTouchEnd={pressUp}
                    >

                        <GrApple size={isMobile ? 30 : 32} color="#000000" />
                        Podcasts
                    </a>
                    {/* Acast */}


                    <a
                        href="https://shows.acast.com/thenurseandthemidwife"
                        target="_blank"
                        rel="noreferrer"
                        style={{
                            // width: "100%",
                            // maxWidth: 280,
                            //   height: 86,
                            paddingLeft: 50,
                            paddingRight: 50,
                            paddingTop: 27,
                            paddingBottom: 27,
                            background: "#FFFFFF",
                            borderRadius: 10,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textDecoration: "none",
                            border: "1px solid rgba(11,18,32,0.10)",
                            boxShadow: "0 10px 24px rgba(0,0,0,0.12)",
                            color: '#000000',
                            gap: 10,
                            fontSize: isMobile ? 20 : 22,
                            fontFamily: 'Poppins'


                        }}

                        onMouseDown={pressDown}
                        onMouseUp={pressUp}
                        onMouseEnter={hoverIn1}
                        onMouseLeave={hoverOut}
                        onTouchStart={pressDown}
                        onTouchEnd={pressUp}
                    >

                        <img
                            src={acast}
                            alt="Logo"
                            style={{ width: 30, height: 30, objectFit: "cover" }}
                        />
                        Acast
                    </a>

                </div>
            </div>

            {/* ================= FOOTER ================= */}
            <div
                style={{
                    width: screenWidth,
                    background: "#1F6F78",
                    padding: isMobile ? "36px 18px 22px" : "56px 70px 26px",
                    boxSizing: "border-box",
                    color: "#FFFFFF",
                    fontFamily: "Poppins",
                    alignSelf: 'center'
                }}
            >
                {/* Top row */}
                <div
                    style={{
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        alignItems: isMobile ? "center" : "flex-start",
                        justifyContent: "space-between",
                        gap: isMobile ? 32 : 0,
                    }}
                >
                    {/* LOGO */}
                    <div style={{ textAlign: isMobile ? "center" : "left" }}>
                        <div
                            style={{
                                width: isMobile ? 140 : 160,
                                height: isMobile ? 140 : 160,
                                borderRadius: "50%",
                                overflow: "hidden",
                                background: "#fff",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <img
                                src={LOGO}   // 🔁 replace with your imported logo if needed
                                alt="The Nurse and The Midwife"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                }}
                            />
                        </div>
                    </div>

                    {/* QUICK LINKS */}
                    <div style={{ minWidth: 160 }}>

                        <div style={footerTitle}>Quick Links</div>

                        <div
                            style={{
                                marginTop: 10,
                                display: "flex",
                                flexDirection: "column", // ✅ column-wise
                                gap: 10,
                                alignItems: "flex-start",

                            }}
                        >
                            {["Home", "About Hosts", "Episodes", "Mission", "Contact"].map((t) => (
                                <div
                                    style={{
                                        height: isMobile ? 30 : 30,
                                        paddingLeft: 10,
                                        paddingRight: 10,
                                        borderRadius: 999,
                                        //  background: "rgba(255,255,255,0.12)",
                                        //  border: "1px solid rgba(255,255,255,0.16)",
                                        // backdropFilter: "blur(10px)",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 5,
                                        // boxShadow: "0 10px 26px rgba(0,0,0,0.22)",
                                        color: "rgba(255,255,255,0.92)",
                                        fontSize: isMobile ? 14 : 15,
                                        fontWeight: 600,
                                        userSelect: "none",
                                        cursor: "pointer",
                                        transition: "transform 0.15s ease, background 0.15s ease",
                                        whiteSpace: "nowrap",
                                        width: "fit-content",
                                        alignSelf: 'center'
                                    }}
                                    onMouseDown={pressDown}
                                    onMouseUp={pressUp}
                                    onMouseEnter={hoverIn}
                                    onMouseLeave={hoverOut}
                                    onTouchStart={pressDown}
                                    onTouchEnd={pressUp}

                                    key={t}
                                    onClick={() => {
                                        setActiveNav(t);
                                    }}
                                >{t}</div>
                            ))}
                        </div>
                    </div>

                    {/* LISTEN ON */}

                    {/* LISTEN ON */}
                    <div style={{ minWidth: 220 }}>
                        <div style={footerTitle}>Listen On</div>

                        <div
                            style={{
                                marginTop: 10,
                                display: "flex",
                                flexDirection: "column", // ✅ column-wise
                                gap: 10,
                                alignItems: "flex-start",

                            }}
                        >
                            {[
                                {
                                    label: "Spotify",
                                    href: "https://open.spotify.com/", // ✅ put your real link

                                },
                                {
                                    label: "Apple Podcasts",
                                    href: "https://podcasts.apple.com/", // ✅ put your real link

                                },
                                {
                                    label: "Acast",
                                    href: "https://shows.acast.com/thenurseandthemidwife", // ✅ put your real link

                                },
                            ].map((p) => (
                                <a
                                    key={p.label}
                                    href={p.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: "none", alignSelf: 'center' }}
                                >
                                    <div
                                        style={{
                                            height: isMobile ? 30 : 30,
                                            paddingLeft: 10,
                                            paddingRight: 10,
                                            borderRadius: 999,
                                            //  background: "rgba(255,255,255,0.12)",
                                            //  border: "1px solid rgba(255,255,255,0.16)",
                                            // backdropFilter: "blur(10px)",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 5,
                                            // boxShadow: "0 10px 26px rgba(0,0,0,0.22)",
                                            color: "rgba(255,255,255,0.92)",
                                            fontSize: isMobile ? 14 : 15,
                                            fontWeight: 600,
                                            userSelect: "none",
                                            cursor: "pointer",
                                            transition: "transform 0.15s ease, background 0.15s ease",
                                            whiteSpace: "nowrap",
                                            width: "fit-content",
                                            alignSelf: 'center'
                                        }}
                                        onMouseDown={pressDown}
                                        onMouseUp={pressUp}
                                        onMouseEnter={hoverIn}
                                        onMouseLeave={hoverOut}
                                        onTouchStart={pressDown}
                                        onTouchEnd={pressUp}
                                    >
                                        {p.icon}
                                        <div>{p.label}</div>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>



                    {/* SOCIALS */}
                    <div
                        style={{
                            minWidth: 120,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignContent: "center",
                        }}
                    >
                        <div style={footerTitle}>Socials</div>

                        <a
                            href="https://www.instagram.com/thenurseandthemidwife?igsh=MzVsZ3BvMHJtMXVw&utm_source=qr"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                marginTop: 10,
                                width: 36,
                                height: 36,
                                borderRadius: 8,
                                border: "1.5px solid rgba(255,255,255,0.7)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                alignSelf: "center",
                                textDecoration: "none",
                                transition: "transform 0.15s ease, background 0.15s ease",
                            }}
                            onMouseDown={pressDown}
                            onMouseUp={pressUp}
                            onMouseEnter={hoverIn}
                            onMouseLeave={hoverOut}
                            onTouchStart={pressDown}
                            onTouchEnd={pressUp}
                        >
                            {/* Instagram Icon */}
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                <rect x="3" y="3" width="18" height="18" rx="5" stroke="white" strokeWidth="2" />
                                <circle cx="12" cy="12" r="4" stroke="white" strokeWidth="2" />
                                <circle cx="17" cy="7" r="1" fill="white" />
                            </svg>
                        </a>
                    </div>

                </div>

                {/* Divider */}
                <div
                    style={{
                        width: "100%",
                        height: 1,
                        background: "rgba(255,255,255,0.25)",
                        margin: isMobile ? "32px 0 16px" : "44px 0 18px",
                    }}
                />

                {/* COPYRIGHT */}
                <div
                    style={{
                        textAlign: "center",
                        fontSize: isMobile ? 13 : 14,
                        opacity: 0.9,
                        letterSpacing: 0.3,
                    }}
                >
                    Copyright © 2025 by the nurse and the midwife. All Rights Reserved. (Version: 1.5)
                </div>
            </div>

            {/* ================= STYLES ================= */}

            {/* ================= FIXED BOTTOM PLAYER ================= */}


            {
                activeEp ? (
                    <div
                        style={{
                            position: "fixed",
                            left: 0,
                            right: 0,
                            bottom: 0,
                            width: "100%",
                            zIndex: 9999,
                            background: "#1F6F78",
                            boxShadow: "0 -18px 55px rgba(0,0,0,0.25)",
                            paddingBottom: "env(safe-area-inset-bottom)",
                        }}
                    >
                        <div
                            style={{
                                width: isMobile ? "95%" : screenWidth * 0.94,
                                marginLeft: "auto",
                                marginRight: "auto",
                                padding: isMobile ? "14px 0 14px" : "18px 0 18px",
                                fontFamily: "Poppins",
                                color: "#FFFFFF",
                                boxSizing: "border-box",
                            }}
                        >
                            {/* ✅ IMPORTANT: keep the audio element HERE so it always exists */}
                            <audio ref={audioRef} preload="metadata" />

                            {/* ================= TOP LINE (title + episode + subtitle centered) ================= */}
                            <div style={{ display: "grid", gridTemplateColumns: "1fr", rowGap: 6 }}>
                                <div
                                    style={{
                                        fontSize: isMobile ? 14 : 22,
                                        fontWeight: 650,
                                        letterSpacing: 0.2,
                                        lineHeight: isMobile ? "14px" : "22px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        maxWidth: "100%",
                                    }}
                                >
                                    {activeEp.mainTitle || activeEp.title}
                                </div>

                                <div style={{ opacity: 0.9, fontSize: isMobile ? 11 : 13, fontWeight: 600 }}>
                                    Episode {activeEp.episodeNumber}
                                </div>
                                {/*
                            <div
                                style={{
                                    fontSize: isMobile ? 12 : 14,
                                    fontWeight: 500,
                                    opacity: 0.95,
                                    letterSpacing: 0.2,
                                    textAlign: "center",
                                    marginTop: isMobile ? 0 : 0,
                                }}
                            >
                                {activeEp.subtitle || "INTRODUCTION TO THE PODCAST"}
                            </div>
*/}
                            </div>

                            {/* ================= SEEK BAR ================= */}
                            <div
                                style={{
                                    marginTop: 10,
                                    display: "grid",
                                    gridTemplateColumns: isMobile ? "45px 1fr 45px" : "56px 1fr 56px",
                                    gap: 10,
                                    alignItems: "center",
                                }}
                            >
                                <div style={{ fontSize: isMobile ? 11 : 13, opacity: 0.95, fontWeight: 600 }}>{fmt(cur)}</div>

                                <input
                                    type="range"
                                    min={0}
                                    max={1000}
                                    value={dur ? Math.round((cur / dur) * 1000) : 0}
                                    onChange={(e) => seekTo(e.target.value)}
                                    style={{
                                        width: "100%",
                                        accentColor: "rgba(255,255,255,0.95)",
                                        cursor: "pointer",
                                    }}
                                />

                                <div style={{ fontSize: isMobile ? 11 : 13, opacity: 0.95, fontWeight: 600, textAlign: "right" }}>
                                    {fmt(dur)}
                                </div>
                            </div>

                            {/* ================= CONTROLS + VOLUME ================= */}
                            <div
                                style={{
                                    marginTop: isMobile ? 5 : 14,
                                    display: "grid",
                                    gridTemplateColumns: isMobile ? "1fr" : "auto 1fr",
                                    rowGap: isMobile ? 5 : 0,
                                    alignItems: "center",
                                    width: "100%",
                                }}
                            >
                                {/* controls */}
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: isMobile ? "42px 46px 42px" : "42px 72px 42px",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        columnGap: 15,
                                        justifySelf: isMobile ? "center" : "center", // ✅ keep centered
                                        //  backgroundColor:'red'
                                    }}
                                >
                                    <button
                                        onClick={goPrev}
                                        disabled={!canPrev}
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            color: "white",
                                            cursor: canPrev ? "pointer" : "not-allowed",
                                            opacity: canPrev ? 1 : 0.35,
                                            width: 42,
                                            height: 42,
                                            display: "grid",
                                            placeItems: "center",
                                            fontSize: 20,
                                        }}
                                        title="Previous"
                                    >
                                        ⏮
                                    </button>

                                    <button
                                        onClick={togglePlay}
                                        style={{
                                            border: "none",
                                            cursor: "pointer",
                                            width: isMobile ? 46 : 72,
                                            height: isMobile ? 46 : 72,
                                            borderRadius: 999,
                                            background: "rgba(255,255,255,0.90)",
                                            color: "#0B1220",
                                            display: "grid",
                                            placeItems: "center",
                                            boxShadow: "0 14px 28px rgba(0,0,0,0.22)",
                                            fontWeight: 900,
                                            fontSize: isMobile ? 16 : 22,
                                        }}
                                        title={isPlaying ? "Pause" : "Play"}
                                    >
                                        {isPlaying ? "❚❚" : "▶"}
                                    </button>

                                    <button
                                        onClick={goNext}
                                        disabled={!canNext}
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            color: "white",
                                            cursor: canNext ? "pointer" : "not-allowed",
                                            opacity: canNext ? 1 : 0.35,
                                            width: 42,
                                            height: 42,
                                            display: "grid",
                                            placeItems: "center",
                                            fontSize: 20,
                                        }}
                                        title="Next"
                                    >
                                        ⏭
                                    </button>
                                </div>

                                {/* volume */}
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: isMobile ? "center" : "flex-end",
                                        alignItems: "center",
                                        gap: 10,
                                        justifySelf: isMobile ? "center" : "end", // 
                                    }}
                                >
                                    <div style={{ fontSize: isMobile ? 14 : 18, opacity: 0.95 }}>🔊</div>
                                    <input
                                        type="range"
                                        min={0}
                                        max={1}
                                        step={0.01}
                                        value={vol}
                                        onChange={(e) => setVol(Number(e.target.value))}
                                        style={{
                                            width: isMobile ? "60%" : 160,
                                            maxWidth: isMobile ? 240 : 160,
                                            accentColor: "rgba(255,255,255,0.95)",
                                            cursor: "pointer",
                                        }}
                                    />
                                </div>
                            </div>

                            {/* ================= VIEW ALL ================= */}
                            <div
                                style={{
                                    marginTop: isMobile ? 8 : 14,
                                    display: "flex",
                                    justifyContent: isMobile ? "center" : "flex-end",
                                    alignItems: "center",
                                }}
                            >
                                <button


                                    onClick={() => navigate("/All_episod", { state: { episodes } })}

                                    style={{
                                        border: "none",
                                        background: "transparent",
                                        cursor: "pointer",
                                        color: "#FFFFFF",
                                        fontWeight: 600,
                                        fontSize: isMobile ? 12 : 16,
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 6,
                                        padding: "6px 4px",

                                        letterSpacing: 0.2,
                                        fontFamily: "sans-serif"
                                    }}

                                    onMouseDown={pressDown}
                                    onMouseUp={pressUp}
                                    onMouseEnter={hoverIn}
                                    onMouseLeave={hoverOut}
                                    onTouchStart={pressDown}
                                    onTouchEnd={pressUp}
                                >
                                    View All Episodes
                                    <FaArrowRightLong color="#FFFFFF" />
                                </button>
                            </div>
                        </div>
                    </div>
                ) : null
            }



        </div >
    );
}

export default Home;

//  <Button onClick={() => navigate('/Sign_up')} style={{ width: 190, height: 53, position:'absolute',top:30,right:30, borderWidth: 1, borderStyle: 'solid', borderColor: '#26B8AD',backgroundColor:'#F7941D',borderRadius:10 }} ><Typography textTransform={'Upercase'} style={{ fontFamily: "Open Sans", color: '#000000',fontSize:24,fontWeight:'700' }} >R</Typography><Typography textTransform={'lowercase'} style={{ fontFamily: "Open Sans", color: '#000000',fontSize:24,fontWeight:'700' }} >egister</Typography></Button>
